import { useEffect, useState } from 'react';

import {
  ModuleNameEnum,
  useCreateAddOnTaskLazyQuery,
  GetEncounterTaskByEncounterTaskIdQuery,
} from 'generated/graphql';

import { Logger } from 'utils';
import { Tokens } from 'config';
import { useToastMessage } from 'hooks';
import UI from 'ui';
import * as Options from './enumsToOptions';
import { TModalState, TSetModalState } from './types';

const AddFormModal = ({
  encounter,
  setModalState,
  modalState,
}: {
  encounter?: NonNullable<
    GetEncounterTaskByEncounterTaskIdQuery['encounterTask']
  >['encounter'];
  setModalState: TSetModalState;
  modalState: TModalState;
}): JSX.Element => {
  const [createAddOnTask, { data, error }] = useCreateAddOnTaskLazyQuery();
  const { setToastMessage } = useToastMessage();

  const [moduleName, setModuleName] = useState(ModuleNameEnum.DEFAULT);
  const [moduleNameLabel, setModuleNameLabel] = useState('');

  const addFormModalContent = (
    <>
      <p
        style={{
          marginBottom: `calc(${Tokens.rhythm} * 2)`,
          marginTop: '0px',
        }}
      >
        The selected form will be added to the{' '}
        <strong>
          {encounter?.serviceLine?.name} - {encounter?.serviceLine?.subType}
        </strong>{' '}
        encounter.
      </p>
      <UI.Select
        id="module"
        label={'Select a form'}
        name="module"
        options={Options.AddFormModuleOptions}
        onChange={(selectedOption) => {
          if (selectedOption) {
            setModuleName(selectedOption[0].value as ModuleNameEnum);
            setModuleNameLabel(selectedOption[0].label);
          }
        }}
      />
    </>
  );

  useEffect(() => {
    if (data) {
      setToastMessage(
        `Successfully added form: ${moduleNameLabel}`,
        UI.Toast.SeverityLevel.Success,
      );
      setModalState({
        selectedType: null,
        isOpen: false,
      });
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      Logger.error(error);
      setToastMessage(`Failed to add task`, UI.Toast.SeverityLevel.Error);
    }
  }, [error]);

  return (
    <UI.Modal
      body={addFormModalContent}
      closeButtonLabel="Cancel"
      onClose={() => {
        setModalState({
          selectedType: null,
          isOpen: false,
        });
      }}
      title={'Add form'}
      size="small"
      open={modalState.isOpen}
      footerButtons={[
        {
          name: 'addFormButton',
          children: 'Add Module',
          variant: 'primary',
          size: 'small',
          onClick: () => {
            if (moduleName !== ModuleNameEnum.DEFAULT) {
              createAddOnTask({
                variables: {
                  id: encounter?.encounterId as number,
                  moduleName,
                },
              });
            }
          },
        },
      ]}
    />
  );
};

export default AddFormModal;
